import TableList from "@components/templates/tablelist";
import { HttpGetInventoryAdjustmentList } from "@/service/inventoryadjustment";
import { mapState, mapGetters } from "vuex";
import mixin from './../mixin'
import comView from './detail.vue'
import compSubmit from './confirm.vue'
import {HttpCusWareList} from "@mods/service/dictionary";
export default {
    mixins: [TableList, mixin],
    components: {
        comView,
        compSubmit
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    // 'IN_orderStatus':null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
            warehouseList: [],
            productList: [],
        };
    },
    created() {

        HttpCusWareList().then(res => {
            console.log(res)
        }, err => {})
    },
    methods: {
        ajaxRequest: HttpGetInventoryAdjustmentList,
        interceptRequest: (params) => {
            let data = params
            data.sku = data.search.sku
            delete data.search.sku
            return {
                ...data,
                state: 0
            }
        },
        handleOperates(params = "", type, batch) {
            const { id,adjustmentOrderNo, adjustmentOrderStatus } = params
            console.log(params);
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "comView",
                        id: id,
                        state: 0,
                        type: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "adjustmentDetail",
                        params: { type: "query" },
                        query: { id: id},
                    });
                    console.log(url);
                    window.open(url.href, '_blank');
                    break;
                case "commit":
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.alloment.button_audit', { defaultValue: '审核' }),
                        width: 460,
                        id: id,
                        orderNo: adjustmentOrderNo,
                        type: 4,
                        component: compSubmit,
                        showFooter: false,
                    };
                    break;
                case "complete":
                    this.operate = {
                        show: true,
                        title: this.$t('global.common.finish', { defaultValue: "完成" }),
                        width: 460,
                        id: id,
                        orderNo:adjustmentOrderNo,
                        type: 5,
                        otherParams: {
                            noRequired: true
                        },
                        component: compSubmit,
                        showFooter: false,
                    }
                    break;
                case "addremark":
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.inbound.add_remark', { defaultValue: '添加备注' }),
                        width: 460,
                        id: id,
                        orderNo:adjustmentOrderNo,
                        type: 10,
                        otherParams: {
                            noRequired: true
                        },
                        component: compSubmit,
                        showFooter: false,
                    }
                    break;
                case "export":
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/inventory/adjustment/export",
                    {
                        state: 0,
                        sku: this.formData.sku,
                        search: {
                            ...this.formData.search
                        }
                    }
                    , {
                        executor: 'request',
                        download: true,
                    }).catch(err => {
                        this.$VMessage.error(err.message);
                    });
                    break;
                case "import":
                    this.operate = {
                        show: true,
                        title: '导入',
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/inventory/adjustment/importAdjustmentOrder",
                        name: "multipartFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/inventory/adjustment/adjustmentTemplate", {}, 'download');
                        },
                        on: {
                            "on-success": () => {
                                this.$emit('on-close');
                                this.$emit('on-update');
                            }
                        }
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id,adjustmentOrderNo, adjustmentOrderStatus } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: row,
                    operate: 'query'
                },
                {
                    label: this.$t('fbb.alloment.button_audit', { defaultValue: '审核' }),
                    show: (adjustmentOrderStatus === 5||adjustmentOrderStatus === 10) && this.handleAuth('fbb.inventoryadjustment.approve'),
                    params: row,
                    operate: 'commit'
                },
                {
                    label: this.$t('global.common.finish', { defaultValue: "完成" }),
                    show: (adjustmentOrderStatus === 5||adjustmentOrderStatus === 10) && this.handleAuth('fbb.inventoryadjustment.complete'),
                    params: row,
                    operate: 'complete'
                },
                {
                    label: this.$t('fbb.inbound.add_remark', { defaultValue: '添加备注' }),
                    show: adjustmentOrderStatus === 5||adjustmentOrderStatus === 10||adjustmentOrderStatus === 70,
                    params: row,
                    operate: 'addremark'
                }
            ]
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getCusproductList', 'getFilterDisabledWarehouse', 'getBillcusorgList']),
        TabsData() {
            return [
                {
                    name: this.$t('global.common.all', { defaultValue: "全部" }),
                    key: 'EQ_adjustmentOrderStatus',
                    val: ''
                },
                {
                    name: this.$t('fbb.inbound.check_pending', { defaultValue: "待审核" }),
                    key: 'EQ_adjustmentOrderStatus',
                    val: 5,
                },
                {
                    name: this.$t('fbb.inventory.part_processing', { defaultValue: '部分处理' }),
                    key: 'EQ_adjustmentOrderStatus',
                    val: 10,
                },
                {
                    name: this.$t('global.common.finished', { defaultValue: "已完成" }),
                    key: 'EQ_adjustmentOrderStatus',
                    val: 70
                },
            ]
        },
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'export',
                },
                {
                    name: "导入",
                    operate: 'import',
                    show: this.handleAuth('fbb.inventory_adjustment.import'),
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [
                {
                    label: this.$t('fbb.inbound.client_organization', { defaultValue: '客户' }),
                    tag: 'Select',
                    key: 'IN_organizationId',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('fbb.inventoryadjustment.adjustment_order_no', { defaultValue: "库存异动单号" }),
                    tag: 'vInput',
                    key: 'EQ_adjustmentOrderNo',
                    show: true,
                    style: 'width: 120px;'
                },
                {
                    label: this.$t('fbb.headlogistics.associated_number', { defaultValue: '来源单号' }),
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    show: true,
                    style: 'width: 120px;'
                },
                {
                    label: this.$t('global.common.status', { defaultValue: "状态" }),
                    tag: 'Select',
                    key: 'IN_adjustmentOrderStatus',
                    show: true,
                    options: this.getInventoryAdjustmentStatus,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: 'width: 120px;'
                },
                {
                    label: this.$t('fbb.costmanage.work_type', { defaultValue: "业务类型" }),
                    tag: 'Select',
                    key: 'IN_type',
                    props: {
                        multiple: true
                    },
                    options: this.getAdjustmentBusinessType,
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    tag: 'Select',
                    key: 'EQ_orgWarehouseId',
                    options: this.getFilterDisabledWarehouse,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.sku', { defaultValue: "SKU" }),
                    tag: 'vInput',
                    key: 'sku',
                    show: true,
                    style: 'width: 120px;'
                }
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id',
                    // fixed: 'left'
                }, {
                    title: this.$t('global.common.operation',{defaultValue:'操作'}),
                    width: 70,
                    render: this.getOperateNodes,
                    // fixed: 'left'
                }, {
                    title: this.$t('fbb.inbound.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    // fixed: 'left',
                    render: (h, { row }) => {
                        let orgName = this.getBillcusorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return (
                            <div>
                                <div>{orgName.label}</div>
                            </div>
                        )
                    }
                }, {
                    title: this.$t('fbb.inventoryadjustment.adjustment_order_no', { defaultValue: "库存异动单号" })+'/'+this.$t('global.common.source_number', { defaultValue: '来源单号' }),
                    sortable: true,
                    // fixed: 'left',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row, 'query')}>{row.adjustmentOrderNo || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                            <div>{row.sourceNo || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('global.common.status', { defaultValue: "状态" }),
                    // key: 'sourceChannel',
                    // width: (this.formData.search['quanbu'] === 0) ? 100 : 'auto',
                    render: (h, { row }) => {
                        let statusName = this.getInventoryAdjustmentStatus.filter(item => {
                            return item.value === row.adjustmentOrderStatus
                        })[0] || {}
                        return (
                            <div>
                                {statusName.label || '--'}
                            </div>
                        )
                    }
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    // width: 60,
                    render: (h, { row }) => {
                        return <div>
                            <div>{`${row.orgWarehouseCode}`}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    width: 180,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.updatedAt}</div>
                        </div>
                    }
                },
            ];
        },

    },

};
